export default __webpack_public_path__ + "static/media/safari.be2beab1.png";